import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'checking': false,
  'warranty': null,
  'loading': false,
};

export const updateWarrantyAdmin = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.UPDATING_TWC_WARRANTIES_ADMIN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_TWC_WARRANTIES_ADMIN]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'warranty': action.response.data,
      });
    },
    [ActionTypes.UPDATED_TWC_WARRANTIES_ADMIN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'warranty': null,
    }),
    [ActionTypes.CHECKING_TWC_WARRANTIES_CHASSIS_KM]: (state, action) => ({
      ...state,
      'checking': true,
    }),
    [ActionTypes.CHECKED_TWC_WARRANTIES_CHASSIS_KM]: (state, action) => ({
      ...state,
      'checking': false,
      'warranty': {...state, 'invalidKm': action.response.data},
    }),
    [ActionTypes.CHECKED_TWC_WARRANTIES_CHASSIS_KM_FAILED]: (state, action) => ({
      ...state,
      'checking': false,
    }),
  })(state, action);
};
